<div class="page">
  <app-qualite [inline]="true"></app-qualite>

  <div class="card">
    <div class="card-header enhanced">
      <div class="header-top">
        <div class="title-section">
          <div class="title-with-selector">
            <h1>{{ 'pilotage.statistiques.header.title' | translate }}</h1>
            <div class="month-selector">
              <select [(ngModel)]="selectedMonth" (change)="onMonthChange()" class="month-select">
                <option *ngFor="let month of getAvailableMonths()" [value]="month.value">{{ month.label }}</option>
              </select>
            </div>
          </div>
          <p class="subtitle" [innerHTML]="'pilotage.statistiques.header.subtitle' | translate"></p>
        </div>
        <div class="header-buttons">
          <button class="btn btn-primary enhanced" (click)="downloadData()" [disabled]="tableLoading">
            <img src="/assets/download.svg" alt="" width="18" height="18" style="filter: brightness(0) invert(1);" />
            <span style="margin-left: 8px;">{{ 'pilotage.statistiques.header.download' | translate }}</span>
          </button>
          <button class="btn btn-toggle" (click)="toggleTableVisibility()" [title]="(isTableVisible ? 'pilotage.statistiques.header.hideTable' : 'pilotage.statistiques.header.showTable') | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <polyline [attr.points]="isTableVisible ? '18 15 12 9 6 15' : '6 9 12 15 18 9'"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="tableLoading" class="state loading">
      <div class="loading-spinner"></div>
      {{ 'pilotage.statistiques.states.loading' | translate }}
    </div>
    
    <div *ngIf="error" class="state error">
      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ error }}
    </div>
    
    <div *ngIf="!error && isTableVisible" class="table-wrapper" [class.loading]="tableLoading">
      <table class="modern-table">
        <thead>
          <tr>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.establishment' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.satisfaction' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.participation' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.waitPerception' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.complaints' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.pendingMessages' | translate }}</th>
            <th class="th-with-icon">{{ 'pilotage.statistiques.table.status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let site of sites; trackBy: trackBySite" class="table-row" [attr.data-status]="getStatusLevel(site)">
            <td class="site-col">
              <span class="site-name">{{ site.name }}</span>
            </td>
            <td class="metric-col">
              <div class="metric">
                <span class="value">{{ formatNumber(site.satisfaction_percentage) }} / 5</span>
                <div class="progress">
                  <div class="fill" [style.width.%]="site.satisfaction_percentage * 20" [attr.data-level]="getSatisfactionLevel(site.satisfaction_percentage)"></div>
                </div>
              </div>
            </td>
            <td class="metric-col">
              <div class="metric">
                <span class="value">{{ formatNumber(site.participation_percentage) }}%</span>
                <div class="progress">
                  <div class="fill" [style.width.%]="site.participation_percentage" [attr.data-level]="getParticipationLevel(site.participation_percentage)"></div>
                </div>
              </div>
            </td>
            <td class="perception-col">
              <span class="perception" [attr.data-type]="(site.wait_perception || 'inconnue').toLowerCase()">{{ site.wait_perception || ('pilotage.statistiques.unknown' | translate) }}</span>
            </td>
            <td class="metric-col">
              <div class="complaint-display">
                <span class="complaint-emoji" [attr.data-level]="getComplaintLevel(site.complaint_percentage)">
                  <svg *ngIf="getComplaintLevel(site.complaint_percentage) === 'high'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  <svg *ngIf="getComplaintLevel(site.complaint_percentage) === 'medium'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                  <svg *ngIf="getComplaintLevel(site.complaint_percentage) === 'low'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </span>
                <span class="complaint-value">{{ formatNumber(site.complaint_percentage) }}%</span>
              </div>
            </td>
            <td class="metric-col center">
              <div class="metric">
                <span class="value">{{ site.pending_replies || 0 }}</span>
              </div>
            </td>
            <td class="status-col">
              <span class="status" [attr.data-status]="getStatusLevel(site)">
                <svg *ngIf="getStatusLevel(site) === 'optimal'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                <svg *ngIf="getStatusLevel(site) === 'acceptable'" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                <svg *ngIf="getStatusLevel(site) === 'attention'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                {{ getStatusText(site) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>